<template>
  <div  class="demo2">
    <div class="notice">
      <div class="declaration">
        <div style="text-align: center;margin-bottom: 40px;">
          <h1>中颖电子无冲突矿产声明</h1>
        </div>
        <div style="margin-bottom: 40px;">
          <p class="declaration-content">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;冲突矿产最初源自刚果民主共和国 (DRC) 及其邻国的采矿活动，它是一种通过资助武装组织来挑起冲突并侵犯人权而获得收益的做法。根据《2010 年多德-弗兰克华尔街改革和消费者保护法案》的“冲突矿产”条款规定，中颖将积极支持消除我们供应链中利用冲突矿产的做法。</p>
        </div>
        <div style="text-align: right;margin-bottom: 40px;">

          <img src="../../assets/images/about/logo.png" style="margin-right: 20px;">

          <div class="declaration-content-imgspan">
            <span style="font-size: 24px;margin-bottom: 20px">中颖电子</span>
          </div>

        </div>

      </div>
    </div>
  </div>
</template>

<script>
    export default {
        name: "demo2"
    }

</script>

<style >
  .notice{
    padding-top: 33px;
    height: 780px;
    background: url(../../assets/images/about/bj.png);
  }
  .declaration{
    margin: 0 auto;
    padding: 80px;
    height: 100%;
    width: 60%;
    background: #fff;
  }
  .declaration-content{    color: #333333;    font-size: 24px;    line-height: 50px;  }
  .declaration-content-imgspan{    margin: 0 auto;float: right;height: 80px;text-align: center;line-height: 80px;  }
</style>



// WEBPACK FOOTER //
// src/pages/about/sw_notice.vue